export enum AnalyzerLinesType {
    VolatilityChange,
    TimeChange
}
